import { MyReceiptTitleStyled } from "./styles/MyReceiptTitleStyled";

export default function MyReceiptTitle() {
  return <MyReceiptTitleStyled>구매 내역</MyReceiptTitleStyled>;
}
